export default __webpack_public_path__ + "static/media/random3.b7dddc00.jpeg";